import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { OrdersListPage } from '@/features/orders/OrdersListPage';
import { MobileOrders } from '@/features/orders/mobile/MobileOrders';

/**
 * Gli ordini cliente. Esistevano come lettura dentro la scheda cliente e come monte ore
 * dentro la commessa: mancava il posto in cui l'ordine è il soggetto — e con esso il comando
 * che rende rendicontabili le sue righe.
 */
export const Route = createFileRoute('/_app/orders/')({ component: Orders });

/** Due componenti, non un layout che si piega: la tabella da 860px non sta in un telefono. */
function Orders() {
  return useIsMobileShell() ? <MobileOrders /> : <OrdersListPage />;
}
